import React, { useEffect, useState } from 'react';
import settingsService from '../../services/settingsService';
import './MaintenancePage.css';

const MaintenancePage = ({ message, onAdminLogin }) => {
    const [branding, setBranding] = useState({});

    useEffect(() => {
        let cancelled = false;
        settingsService.getPublicSettings().then(settings => {
            if (!cancelled) setBranding(settings);
        });
        return () => { cancelled = true; };
    }, []);

    const loginLogoUrl = branding.login_logo_url;
    const loginBgUrl = branding.login_background_url;
    const companyDisplayName = branding.company_name || 'ConfigSelect';

    const leftStyle = loginBgUrl
        ? { backgroundImage: `url(${loginBgUrl})`, backgroundSize: 'cover', backgroundPosition: 'center' }
        : {};

    return (
        <div className="login-container">
            <div className={`login-left ${loginBgUrl ? 'login-left-image' : ''}`} style={leftStyle}>
                <div className={`login-logo-container ${loginBgUrl ? 'login-logo-overlay' : ''}`}>
                    {loginLogoUrl ? (
                        <img src={loginLogoUrl} alt={companyDisplayName} className="login-logo-img" />
                    ) : (
                        <>
                            <h1 className="login-brand">{companyDisplayName}</h1>
                            <p className="login-tagline">Product Configurator</p>
                        </>
                    )}
                </div>
            </div>
            <div className="login-right">
                <div className="login-form-container maintenance-content">
                    <div className="maintenance-icon">&#128295;</div>
                    <h2>Under Maintenance</h2>
                    <p className="maintenance-message">
                        {message || 'We are currently performing scheduled maintenance. Please check back shortly.'}
                    </p>
                    <div className="maintenance-footer">
                        <a href="#" className="admin-login-link" onClick={(e) => { e.preventDefault(); onAdminLogin(); }}>
                            Administrator Login
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MaintenancePage;
